<template>
    <div class="container pt-5 pb-5 page">
        <h1>Contact</h1>
        <p>
            Of u nu vragen heeft, kennis wilt maken of meer informatie nodig heeft, neem dan gerust contact met ons op. We helpen u graag verder.
        </p>
        <address>
            <strong>Azurity Beveiliging B.V.</strong><br />
            Endegeesterstraatweg 3<br />
            2342 AJ, Oegstgeest<br />
            Nederland<br /><br />
            <abbr title="WhatsApp" class="primary"><font-awesome-icon :icon="['fab', 'whatsapp']"></font-awesome-icon></abbr>&nbsp;<a href="https://wa.me/31640000933" rel="noopener" target="_blank">06-40000933</a><br />
            <abbr title="Email" class="primary"><font-awesome-icon icon="envelope"></font-awesome-icon></abbr>&nbsp;<a href="mailto:info@azurity.nl" rel="noopener">info@azurity.nl</a><br /><br />
            <abbr title="Kamer van Koophandel">KvK</abbr>: 56312008<br />
            <abbr title="Vergunning">Vergunning</abbr>: ND 5590
        </address>
        <hr>
        <h2>Contactformulier</h2>
        <contact-form></contact-form>
    </div>
</template>

<script>
import ContactForm from '@/components/ContactForm'

export default {
    components: {
        'contact-form': ContactForm
    }
}
</script>